import React, { useState } from 'react'

import './style.scss'

export default function ReactColor({ currentValue, inputName, options }) {
  const [selectedColor, setSelectedColor] = useState(currentValue?.toUpperCase() || '')

  return (
    <div className='d-block'>
      <input name={inputName} value={selectedColor} readOnly className='d-none' />
      <div className='d-flex'>
        <span className={`fa fa-ban me-2 ${!selectedColor && 'ban-selected'}`} onClick={() => setSelectedColor('')} />
        {options.map(color => (
          <span
            key={color}
            className={`circle ${selectedColor === color && 'color-selected'}`}
            style={{ backgroundColor: color }}
            onClick={() => setSelectedColor(color)}
          />
        ))}
      </div>
    </div>
  )
}
